<template>
  <div id="Summary" class="Summary">
    <div v-if="!pickup.wareHouseAddress" class="list-item">
      <div class="title">提货地址</div>

      <div class="lable-item">
        <div class="lable">联系人姓名</div>
        <span class="content">{{ pickup.name }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">详细地址</div>
        <span class="content">{{ pickup.address }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">联系电话</div>
        <span class="content">{{ pickup.tel }}</span>
      </div>

    </div>
    <div v-if="pickup.wareHouseAddress" class="list-item">
      <div class="title">送仓地址信息</div>
      <div class="lable-item">
        <div class="lable">联系人</div>
        <span class="content">{{ pickup.wareHouseContact }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">联系电话</div>
        <span class="content">{{ pickup.wareHouseTel }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">仓库地址</div>
        <span class="content">{{ pickup.wareHouseAddress }}</span>
      </div>
    </div>
    <div class="list-item">
      <div class="title">收件人信息</div>
      <div class="lable-item">
        <div class="lable">公司名称</div>
        <span class="content">{{ receiver.companyName }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">联系人名称</div>
        <span class="content">{{ receiver.name }}</span>
      </div>
      <div class="flex">
        <div class="lable-item" style="width:50%">
          <div class="lable" style="width: 40%;">国家</div>
          <span class="content">{{ receiver.countryName }}</span>
        </div>
        <div class="lable-item" style="width:50%">
          <div class="lable" style="width: 40%;">省/州</div>
          <span class="content">{{ receiver.provinceName }}</span>
        </div>
      </div>
      <div class="flex">
        <div class="lable-item" style="width:50%">
          <div class="lable" style="width: 40%;">城市</div>
          <span class="content">{{ receiver.cityName }}</span>
        </div>
        <div class="lable-item" style="width:50%">
          <div class="lable" style="width: 40%;">邮编</div>
          <span class="content">{{ receiver.zipCode }}</span>
        </div>
      </div>

      <div class="lable-item">
        <div class="lable">详细地址</div>
        <span class="content">{{ receiver.address }}</span>
      </div>
      <div class="flex">
        <div class="lable-item" style="width:50%">
          <div class="lable" style="width: 40%;">联系电话</div>
          <span class="content">{{ receiver.tel }}</span>
        </div>
        <div class="lable-item" style="width:50%">
          <div class="lable" style="width: 40%;">联系邮箱</div>
          <span class="content">{{ receiver.email }}</span>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import {
  GetOrderAddress,
  GetPickupAddress
} from '@/api/order.js'
export default {
  name: 'Summary',
  components: {
    // 组件的引用
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      data: {},
      shipper: {},
      receiver: {},
      pickup: {},
      delivery: {}
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    init(data) {
      this.data = data
	  console.log(JSON.stringify(data))
      GetOrderAddress({
        orderNo: this.data.orderNo,
        addrType: 0
      }).then(res => {
        if (res.code == 200) {
          this.shipper = res.data
        }
      })
      GetOrderAddress({
        orderNo: this.data.orderNo,
        addrType: 1
      }).then(res => {
        if (res.code == 200) {
          this.receiver = res.data
        }
      })
      GetPickupAddress(this.data.orderNo).then(res => {
        if (res.code == 200) {
          this.pickup = res.data
        }
      })
      GetOrderAddress({
        orderNo: this.data.orderNo,
        addrType: 7
      }).then(res => {
        if (res.code == 200) {
          this.delivery = res.data
        }
      })
    }
  }
}
</script>
<style scoped lang='scss'>
	.Summary {
		display: flex;
		flex-wrap: wrap;
		width: auto;
		padding: 0 20px 16px;

		.list-item {
			width: 524px;
			background: #F5F6F9;
			border-radius: 8px;
			padding: 8px 20px;
			margin: 0 8px;
			text-align: left;

			.title {
				font-size: 14px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				color: #333333;
				height: 32px;
				line-height: 32px;
			}

			.lable-item {
				display: flex;
				height: 40px;
				align-items: center;

				.lable {
					font-size: 13px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					color: #666666;
					width: 20%;
				}

				.content {
					font-size: 13px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					color: #333333;
				}

				.content-cancel {
					color: #E95506;
					margin-left: 10px;
					cursor: pointer;
				}
			}
		}
	}
</style>
